// src/pages/Admin/UsersCategoryView.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import PaginatedTable from '../../components/PaginatedTable';
import TitleWithBack from '../../components/common/TitleWithBack';
import { useDialog } from '../../context/DialogContext';

function UsersCategoryView() {
  const { alert } = useDialog();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  const fetchCategories = (keyword = '') => {
    setLoading(true);
    const url = keyword
      ? `/api/user-categories/search?keyword=${encodeURIComponent(keyword)}&page=0&size=10&sortBy=id`
      : `/api/user-categories?page=0&size=10&sortBy=id`;
    axios
      .get(url)
      .then((response) => {
        const data = response.data;
        const catArray = Array.isArray(data)
          ? data
          : data && Array.isArray(data.content)
          ? data.content
          : [];
        setCategories(catArray);
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching user categories.');
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchCategories(searchKeyword);
  };

  const handleEdit = (id) => {
    navigate(`/admin/users/category/edit/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/user-categories/${id}`);
      fetchCategories(searchKeyword);
      setDeleteId(null);
    } catch (err) {
      alert('Error deleting category.', { title: 'Error', variant: 'danger' });
    }
  };

  const columns = [
    { key: 'name', header: 'Name' },
    { key: 'description', header: 'Description' },
    { key: 'actions', header: 'Actions' }
  ];

  const renderRow = (cat) => (
    <>
      <td>{cat.name}</td>
      <td>{cat.description}</td>
      <td>
        <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(cat.id)}>
          Edit
        </button>
        <button className="btn btn-sm btn-danger" onClick={() => setDeleteId(cat.id)}>
          Delete
        </button>
      </td>
    </>
  );

  return (
    <div className="container-fluid mt-2 px-4">
      <TitleWithBack title="User Categories" />
      <button className="btn btn-primary mb-3" onClick={() => navigate('/admin/users/category')}>
        Create New Category
      </button>
      <form onSubmit={handleSearch} className="mb-3">
        <div className="input-group">
          <input 
            type="text" 
            className="form-control" 
            placeholder="Search categories..." 
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
          <button className="btn btn-secondary" type="submit">Search</button>
        </div>
      </form>
      {loading ? (
        <p>Loading categories...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : categories.length === 0 ? (
        <p>Nothing to show here</p>
      ) : (
        <PaginatedTable
          data={categories}
          columns={columns}
          renderRow={renderRow}
          rowsPerPage={50}
        />
      )}
      {deleteId && (
        <ConfirmationModal 
          title="Confirm Delete"
          message="Are you sure you want to delete this category?"
          onConfirm={() => handleDelete(deleteId)}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </div>
  );
}

export default UsersCategoryView;
